import { all, takeLatest, call, put, delay } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import {
  getUsersSuccess,
  getUsersFailure,
  getUserDetailsSuccess,
  getUserDetailsFailure,
  getOrganisationGroupsSuccess,
  getOrganisationGroupsFailure
} from './actions';
import { SysAdminUserActionTypes } from './types';
import {
  getFreePlanUsers,
  getFreePlanUserDetails,
  getOrganisationGroups,
  upgradeFreePlan
} from 'services/super-admin.service';
import { SysAdminOrgActionTypes } from '../../sysAdminOrg/localStore/types';
import {
  createOrganisationFailure,
  createOrganisationReset,
  createOrganisationSuccess
} from './actions';

function* handleGetUsers(request: any) {
  const emptyErrorText = 'Unable to get users.';
  try {
    const response: AxiosResponse = yield call(
      getFreePlanUsers,
      request.payload
    );
    if (Array.isArray(response?.data?.users)) {
      yield put(
        getUsersSuccess({
          count: response.data.count,
          data: response.data.users
        })
      );
    } else {
      yield put(getUsersFailure(emptyErrorText));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(getUsersFailure(msg || emptyErrorText));
  }
}

function* handleGetUserDetails(request: any) {
  const emptyErrorText = 'Unable to get user details.';
  try {
    const response: AxiosResponse = yield call(
      getFreePlanUserDetails,
      request.payload
    );
    if (response?.data?.id) {
      yield put(getUserDetailsSuccess(response.data));
    } else {
      yield put(getUserDetailsFailure(emptyErrorText));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(getUserDetailsFailure(msg || emptyErrorText));
  }
}

function* handleGetOrganisationGroups() {
  const emptyErrorText = 'Unable to get organisation groups.';
  try {
    const response: AxiosResponse = yield call(getOrganisationGroups);
    if (Array.isArray(response?.data)) {
      yield put(getOrganisationGroupsSuccess(response.data));
    } else {
      yield put(getOrganisationGroupsFailure(emptyErrorText));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(getOrganisationGroupsFailure(msg || emptyErrorText));
  }
}

function* handleCreateOrganisation(request: any) {
  const emptyErrorText = 'Unable to create new organisation.';
  try {
    const response: AxiosResponse = yield call(
      upgradeFreePlan,
      request.payload
    );
    if (response?.data?.status === 'success') {
      yield put(createOrganisationSuccess());
    } else {
      yield put(createOrganisationFailure(emptyErrorText));
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(createOrganisationFailure(msg || emptyErrorText));
  }
  yield delay(2000);
  yield put(createOrganisationReset());
}

function* watchGetUsers() {
  yield takeLatest(SysAdminUserActionTypes.GET_USERS_START, handleGetUsers);
}

function* watchGetUserDetails() {
  yield takeLatest(
    SysAdminUserActionTypes.GET_USER_DETAILS_START,
    handleGetUserDetails
  );
}

function* watchGetOrganisationGroups() {
  yield takeLatest(
    SysAdminOrgActionTypes.GET_ORGANISATION_GROUPS_START,
    handleGetOrganisationGroups
  );
}

function* watchCreateOrganisation() {
  yield takeLatest(
    SysAdminUserActionTypes.FREE_PLAN_UPGRADE_START,
    handleCreateOrganisation
  );
}

function* sagas() {
  yield all([
    call(watchGetUsers),
    call(watchGetUserDetails),
    call(watchGetOrganisationGroups),
    call(watchCreateOrganisation)
  ]);
}

export default sagas;
